// Multi-currency display helpers. Base data currency is USD; INR is a display/billing layer.

export const CURRENCY_SYMBOLS = { USD: "$", INR: "₹" };

export function currencySymbol(currency) {
  return CURRENCY_SYMBOLS[(currency || "USD").toUpperCase()] || "$";
}

// Format a numeric amount with the right symbol and 2 decimals.
export function formatMoney(amount, currency = "USD", opts = {}) {
  const sym = currencySymbol(currency);
  const n = Number(amount || 0);
  const str = n.toLocaleString(undefined, {
    minimumFractionDigits: opts.minimumFractionDigits ?? 2,
    maximumFractionDigits: opts.maximumFractionDigits ?? 2,
  });
  return `${sym}${str}`;
}
